import styled, { css } from "styled-components"

export const StyledLabel = styled.label`
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;

  ${({ simpleForm, theme }) =>
    !!simpleForm &&
    css`
      margin: 0 0 16px;
      color: ${theme.colors.fields.label};
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
    `}

  ${({ simpleForm }) =>
    !simpleForm &&
    css`
      margin: 0.5rem 0;
      display: flex;
      justify-content: space-between;
      color: ${({ theme }) => theme.colors.body};
      font-size: 1rem;
      font-weight: bold;
    `}
`
